import React, { useEffect } from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { Downgraded, useState } from '@hookstate/core';
import
{
    Box, CircularProgress, Slide,
    // CircularProgress,
} from '@mui/material';
import { useEventState } from '../../stores/eventStore';
import { makeStyles } from '@mui/styles';
import { useAuthState } from '../../stores/authStore';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import { FULL_PERMISSION, NO_ACCESS_PERMISSION } from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import { isEmpty } from 'lodash-es';
import RouteConstants from '../../constants/routeConstants';
import DataSocialResList from './dataSocialResList';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import AppConstants from '../../constants/appConstants';
import AdminNote from '../../sharedcomponents/adminNote/adminNote';
import PendingActionDialog from '../../sharedcomponents/confirmationdialog/pendingActionDialog';
import StyledTable1 from '../../sharedcomponents/styledTable/styleTable1';
import CustomDialog from '../../sharedcomponents/dialog/dialog';


const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        marginTop: '180px'
    },
}));
const Transition = React.forwardRef(function Transition(props, ref)
{
    return <Slide direction="up" ref={ref} {...props} />;
});
const SocialResponsibilities = () =>
{
    const classes = useStyles();

    let history = useHistory();
    const showSearch = true;
    // const openDialog = useState(false);
    //const transittype = useState(null);

    const authState = useAuthState();
    const loading = useState(true);
    const allData = useState([]);
    const allListData = useState();
    const eventData = useState(null);
    const userID = useState(null);
    const fullData=useState([]);
    const [allParticipantList, setAllParticipantList] = React.useState()
    const [filterChangeVal, setFilterChangeVal] = React.useState(false);
    const [filters, setFilters] = React.useState(null);
    const setAll = useState(false);
    const openNoteDialog = useState(false);
    const requestNote = useState(null);
    const requestPending = useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const filteredEmty = useState(false);
    const allNote = useState(false)
    const filteredList = useState([]);
    const [allNoteValue, setAllNoteValue] = React.useState('')
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [showStatus, setShowStatus] = React.useState({
        Approved: 0,
        Pending: 0,
        Rejected: 0
    });
    const pendingAction = useState({
        open: false,
        title: '',
        message: '',
    });
    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: 5000,
        noOfPages: null,
    });
    const approveConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const rejectConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });

    const [modPermission, setModPermission] = React.useState(null);
    const eventState = useEventState();

    const userInfo = Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    const [showSocialHistory, setShowSocialHistory] = React.useState(false);
    const [socialRespHistory, setSocialRespHistory] = React.useState();
    const displayName = useState(null);

    const headers = [        
        { key: 'participant', title: 'Name' }, 
        { key: 'title', title: 'Title' },
        { key: 'specialRequest', title: 'Requested Timeslot' },
        // { key: 'preference', title: 'Preference' },       
        { key: 'RequestStatus', title: 'Status' }, 
        { key: 'AuditBy', title: 'Audit By' },
        { key: 'AuditDate', title: 'Audit Date' },
        { key: 'AuditStatus', title: 'Audit Status' },
    ];
    let eventRole = '';
    if (!isEmpty(eventInfo))
    {
        eventRole =
            userInfo && userInfo.roles
                ? userInfo.roles.find(
                    (item) => item.eventID === eventInfo.eventID
                )?.eventRole
                : '';
    }
    useEffect(() =>
    {
        if (eventState && eventState.eventDetail.get())
        {
            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo))
            {
                setModPermission(FULL_PERMISSION);
                userID.set(userInfo.userID);
            } else if (userInfo.roles && Helper.isEventAdmin(userInfo))
            {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                userID.set(userInfo.userID);
                if (permissions && permissions.length > 0)
                {
                    setModPermission(
                        Helper.getModuleAccessPermission(permissions, 'TICKET')
                    );
                }
            }
        }

    }, [eventState]);
    useEffect(() =>
    {
        if (modPermission && modPermission == FULL_PERMISSION)
        {
            getParticipantList();
        }
    }, [modPermission]);
    useEffect(() =>
    {

        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        )
        {
            eventData.set(eventInfo);
            eventInfo.moduleDetails.filter((x) => x.moduleID === AppConstants.EVENT_MODULES.SOCIAL_RESPONSIBILITY).map((item) => {
                displayName.set(item.displayName)
            })
            userID.set(userInfo.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        )
        {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);

    useEffect(() =>
    {
        const pageInfo = pagingInfo.attach(Downgraded).get();
        if (pageInfo.itemsPerPage)
        {
            GetAllSocialResposibility();
        }
    }, []);

    const GetAllSocialResposibility = () =>
    {
        let participantList = [];

        loading.set(true);
        ApiHelper.get(
            APIURLConstants.GET_ALL_SOCIAL_RESPOSIBILITY(
                eventInfo.eventID,
                userInfo.userID,
                userInfo.userType == 'Admin' || !isEmpty(eventRole)
                    ? true
                    : false,
                false,
                pagingInfo.get().currentPage,
                pagingInfo.get().itemsPerPage
            )
        )
            .then((res) =>
            {
                if (res.data)
                {
                    let data = res.data;

                    let resultSocialResponsibility = res.data.reduce(function (
                        r,
                        c
                    )
                    {
                        r[c.userID] = r[c.userID] || {
                            userID: c.userID,
                            socialResponsibilityID: c.socialResponsibilityID,
                            eventID: c.eventID,
                            email: c.email,
                            createdDate: c.createdDate,
                            description: c.description,
                            headerDate: c.headerDate,
                            moduleID: c.moduleID,
                            participant: c.participant,
                            options: [],
                            createdByName: c.createdByName,
                            requestStatus: c.requestStatus,
                            userTags:c.tagIDs,
                            masterID: c.masterID,
                        };
                        r[c.userID].options.push({
                            masterID: c.masterID,
                            title: c.title,
                            preference: c.preference,
                            specialRequest:c.specialRequest,     
                            description: c.description,                                       
                        });

                        return r;
                    },
                        {});
                    let requestData = [];
                    let allRequestData=[];
                    const indexOfLastRecord = pagingInfo.get().currentPage * pagingInfo.get().itemsPerPage;
                const indexOfFirstRecord = indexOfLastRecord - pagingInfo.get().itemsPerPage;
                    if (data.length > 0)
                    {
                        let approved = 0;
                        let pending = 0;
                        let rejected = 0;
                        Object.values(resultSocialResponsibility).slice(indexOfFirstRecord, indexOfLastRecord).map(
                            (item) =>
                            {
                                requestData.push({
                                    actualData: item,
                                    row: [
                                        {
                                            label: 'checkbox',
                                            key: 'socialResponsibilityID',
                                            socialResponsibilityID:
                                                item.socialResponsibilityID,
                                            width: '0.05',
                                            inColumn: true,
                                            alignCenter: true,
                                        },
                                        // {
                                        //     label: 'Participant',
                                        //     key: 'participant',
                                        //     participant: item.participant,
                                        //     width: '0.25',
                                        //     showLabel: false,
                                        //     toEmail: item.email,
                                        //     showEmail: true,
                                        // },
                                        {
                                            label: 'Date',
                                            Date: 'headerDate',
                                            headerDate: item.headerDate,
                                            width: '0.30',
                                            inColumn: true,
                                            // asList: true,
                                            // alignCenter: true,
                                        },
                                        // {
                                        //     label: 'Submitted By',
                                        //     key: 'createdBy',
                                        //     createdBy: item.createdByName,
                                        //     width: '0.20',
                                        //     inColumn: true,
                                        // },

                                        {
                                            label: 'Date',
                                            key: 'createdDate',
                                            createdDate: !Helper.IfDateIsNULL(
                                                item.createdDate
                                            )
                                                ? Helper.FormatDate(
                                                    item.createdDate
                                                ) +
                                                ' ' +
                                                Helper.FormatTime(
                                                    item.createdDate
                                                )
                                                : '',
                                            width: '0.25',
                                            inColumn: true,
                                        },

                                        {
                                            label: 'Action',
                                            key: 'All',
                                            all: 'All',
                                            width: '0.15',
                                            inColumn: true,
                                            alignCenter: true,
                                        },
                                    ],
                                    selected: false,
                                });
                            });
                            Object.values(resultSocialResponsibility).map(
                                (item) =>
                                {
                                    if (item.requestStatus === "Approved")
                                    {
                                        approved += 1;
                                    } else if (item.requestStatus === "Pending")
                                    {
                                        pending += 1;
                                    } else
                                    {
                                        rejected += 1
                                    }
                                    if (
                                        participantList.indexOf(item.participant) ==
                                        -1
                                    )
                                    {
                                        participantList.push(item.participant);
                                    }
                                    allRequestData.push({
                                        actualData: item,
                                        row: [
                                            {
                                                label: 'checkbox',
                                                key: 'socialResponsibilityID',
                                                socialResponsibilityID:
                                                    item.socialResponsibilityID,
                                                width: '0.05',
                                                inColumn: true,
                                                alignCenter: true,
                                            },                                           
                                            {
                                                label: 'Date',
                                                Date: 'headerDate',
                                                headerDate: item.headerDate,
                                                width: '0.30',
                                                inColumn: true,                                               
                                            },
                                            {
                                                label: 'Date',
                                                key: 'createdDate',
                                                createdDate: !Helper.IfDateIsNULL(
                                                    item.createdDate
                                                )
                                                    ? Helper.FormatDate(
                                                        item.createdDate
                                                    ) +
                                                    ' ' +
                                                    Helper.FormatTime(
                                                        item.createdDate
                                                    )
                                                    : '',
                                                width: '0.25',
                                                inColumn: true,
                                            },
                                            {
                                                label: 'History',
                                                key: 'auditHistory',
                                                auditHistory: '',
                                                width: '0.10',
                                                showLabel: false,
                                                showChips: false,
                                                inColumn: true,
                                                // alignCenter: true,
                                            },
                                            {
                                                label: 'Action',
                                                key: 'All',
                                                all: 'All',
                                                width: '0.15',
                                                inColumn: true,
                                                alignCenter: true,
                                            },
                                        ],
                                        selected: false,
                                    });
                                });
                                fullData.set(allRequestData)
                        setShowStatus({ Approved: approved, Pending: pending, Rejected: rejected })
                    } else
                    {
                        <StyledTableRow>
                            <StyledTableCell colSpan="7" align="center">
                                No data found
                            </StyledTableCell>
                        </StyledTableRow>;
                        setShowStatus({ Approved: 0, Pending: 0, Rejected: 0 });
                    }
                    setShowSearchRec(false);
                    let filterData = filteredList.attach(Downgraded).get();
                    if (filterData.length > 0)
                    {
                        setFilterChangeVal(true);
                    }
                    allData.set(requestData);
                    allListData.set(requestData);
                    setFilters({
                        participant: participantList,
                        // requestStatus: statusList.attach(Downgraded).get(),
                    });
                    loading.set(false);

                    if (pagingInfo.get().noOfPages == null)
                    {
                        pagingInfo.set({
                            ...pagingInfo,
                            currentPage: pagingInfo.get().currentPage,
                            itemsPerPage: pagingInfo.get().itemsPerPage,
                            noOfPages: Math.ceil(
                                res.data.totalCount /
                                pagingInfo.get().itemsPerPage
                            ),
                        });
                    }
                }
            })
            .catch((error) =>
            {
                loading.set(false);
                if (error.response && error.response.status === 401)
                {
                    alert(error);
                }
            });
    };

    const handlePageChange = (event, page) =>
    {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        GetAllSocialResposibility();
    };

    //// After Completed New Request Page Then Un Commet

    // const onAddRequest = () => {
    //     // let registeredIds = allData
    //     //     .attach(Downgraded)
    //     //     .get()
    //     //     .map((x) => x.actualData.addedFor);
    //     // let filteredParticipants = participantList.filter(
    //     //     (x) => !registeredIds.includes(x.userID)
    //     // );
    //     props.history.push({
    //         pathname: generatePath(RouteConstants.CREATE_DRAFT_EVENT_HOTEL, {
    //             eventID: eventData.get().eventID,
    //         }),
    //         state: {
    //             hotel: '',
    //             participantList: participantList,
    //             admin: true,
    //         },
    //     });
    //     // openDialog.set(true);
    // };
    const filterListData = (data) =>
    {
        console.log(data);
        if (data.length == 0)
        {
            filteredEmty.set(true);
        } else
        {
            filteredEmty.set(false);
        }
        filteredList.set(data);
    };
    const redirectToEditRequest = (data) =>
    {
        const row = data.actualData;
        const path = generatePath(RouteConstants.SOCIAL_RESPONSIBILITY, {
            eventID: eventInfo.eventID,
            socialResponsibilityID: row.socialResponsibilityID,
        });

        history.push({
            pathname: path,
            state: {
                socialResponsibilityState: row,
                FilterParticpants: null
            },
        });
    };
    const getParticipantList = () =>
    {
        ;
        if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
        )
        {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(eventInfo.eventID)
            ).then((res) =>
            {
                if (res.data.rows)
                {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setAllParticipantList(participants);
                }
            });
        }
    }


    const onAddRequest = () =>
    {
        let userIDs = allData
            .attach(Downgraded)
            .get()
            .map((x) => x.actualData.userID);
        let filteredParticipants = allParticipantList && allParticipantList.filter(
            (x) => !userIDs.includes(x.userID)
        )

        history.push({
            pathname: generatePath(RouteConstants.SOCIAL_RESPONSIBILITY, {
                eventID: eventInfo.eventID,
            }),
            state: {
                socialResponsibilityState: null,
                FilteredParticpants: filteredParticipants
            },
        });
    };

    const onDelete = () =>
    {
        const selected = allData.get().filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length===0)
        {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else
        {
            let message = setAll.get()
                ? 'Do you want to delete all request?'
                : 'Do you want to delete selected request?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };
    const generateExcelReport = async (result) =>
    {
        let selectedIds = [];
        let IDs = null;
        if (result.length > 0)
        {
            result.map((item) =>
            {
                selectedIds.push(item.actualData.socialResponsibilityID);
            });
            IDs = selectedIds.join(',');
        }

        await ApiHelper.post(
            APIURLConstants.Excel_Export,{EventID:eventInfo.eventID, ModuleID:14, IDs:IDs}
        ).then((res) =>
        {
            const finalObject = JSON.parse(res.data.value);
            if (finalObject)
            {
                if (finalObject.length > 0)
                {
                    let header = {};
                    Object.keys(finalObject[0]).map((key) =>
                    {
                        header[key] = key;
                    });

                    finalObject.unshift(header);
                    console.log(finalObject);
                    Helper.downloadReport(
                        finalObject,
                        `SocialResponsibility-Report`
                    );
                }
            }
        });
    };
    const hanldeAllNoteValue = (item) =>
    {
        setAllNoteValue(item)
    }
    const callExport = () =>
    {
        if (filteredList.attach(Downgraded).length !== 0)
        {
            const selected = filteredList
                .get()
                .filter((user) => user.selected === true);
            const allSelected = filteredList
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0)
            {
                generateExcelReport(allSelected);
            } else
            {
                generateExcelReport(selected);
            }
        } else
        {
            const selected = allData
                .get()
                .filter((user) => user.selected === true);
            const allSelected = fullData
                .get()
                .filter((user) => user.selected === false);

            if (selected.length === 0)
            {
                generateExcelReport(allSelected);
            } else
            {
                generateExcelReport(selected);
            }
        }
    };

    const handleConfirmation = () =>
    {
        let deleteRequests = [];
        allData.get().map((row) =>
        {
            if (row.selected === true)
            {
                deleteRequests.push(row.actualData.userID);
            }
        });
        fullData.get().map((row) =>
        {
            if (row.selected === true)
            {
                deleteRequests.push(row.actualData.userID);
            }
        });
        ApiHelper.post(APIURLConstants.DELETE_SOCIAL_RESPONSIBILITY, {
            Ids: deleteRequests.join(','),
            EventID: eventInfo.eventID,
            SoftDelete: true,
            ModifiedBy: userID.value,
        })
            .then((res) =>
            {
                if (res.data)
                {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    //props.onDelete(false);
                    setAll.set(false);
                    GetAllSocialResposibility();
                    //getEmailNotification();
                }
            })
            .catch((error) =>
            {
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };
    const onActionClick = (item, action) =>
    {
        let newData = [...allData.attach(Downgraded).get()];
        let index = newData.findIndex(data => data.actualData.socialResponsibilityID == item.actualData.socialResponsibilityID);
        let newItem = newData[index].actualData;

        const isStatus = action == 'Approve' ? 2 : (action == 'Reject' ? 3 : 1);
        requestNote.set({
            socialResponsibilityID: newItem.socialResponsibilityID,
            status: isStatus,
            userID: userID.get(),
            action,
            item: newItem,
            index,
            note: newItem.note
        });
        openNoteDialog.set(true);
    };
    const onPendingAction = (item) =>
    {
        let newData = [...allData.attach(Downgraded).get()];
        let index = newData.findIndex(data => data.actualData.userID == item.actualData.userID);
        let newItem = newData[index].actualData;

        const isStatus = 1
        requestPending.set({
            status: isStatus,
            modifiedBy: userID.get(),
            userID: newItem.userID,
            eventID: newItem.eventID
        });

        let message = 'Do you want to move request to pending?'

        pendingAction.set({
            open: true,
            title: '',
            OkButtonText: 'Ok',
            message: message,
        });
    }
    const closeNoteDialog = () =>
    {
        openNoteDialog.set(false);
        requestNote.set(null);
    }
    const saveAppNotification = (obj) =>
    {
        console.log(eventInfo)
        let payLoad = {
            appNotificationID: 0,
            userIDs: JSON.stringify(obj.item.userID),
            appNotificationTypeID: 1,
            eventID: eventInfo.eventID,
            moduleID: 14,
            recordRefID: obj.socialResponsibilityID,
            requestStatus: obj.status,
            status: 0,
            createdBy: userID.get(),
        };
        ApiHelper.post(APIURLConstants.SAVE_APP_NOTIFICATION, payLoad).then(res =>
        {
            console.log(res);
            ApiHelper.get(
                APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                    obj.item.userID,
                    eventInfo.eventID,
                    eventInfo.eventName,
                    displayName.get(),
                    obj.status === 2 ? "Approved" : obj.status === 3 ?"Rejected" : "Pending"
                )
            ).then((res) =>
            {
                console.log(res);
            });
        }).catch(err =>
        {
            console.log(err);
        })
    }

    const updateNote = async (value) =>
    {
        let newRequestNote = { ...requestNote.attach(Downgraded).get() };
        console.log(requestNote)
        newRequestNote['note'] = value;
        const statusReq = {
            userID: newRequestNote.item.userID,
            status: newRequestNote.status,
            modifiedBy: newRequestNote.userID,
            eventID: newRequestNote.item.eventID,
            isMail:0
        }
        const req = {
            userID: newRequestNote.item.userID,
            note: newRequestNote.note,
            modifiedBy: newRequestNote.userID,
            eventID: newRequestNote.item.eventID

        };

        ApiHelper.post(APIURLConstants.UPD_SOCIALRESPONSIBILITY_STATUS, statusReq)
            .then(data =>
            {
                if (data.data)
                {
                    ApiHelper.post(APIURLConstants.UPD_SOCIALRESPONSIBILITY_NOTE, req)
                        .then(async (res) =>
                        {
                            if (res.data)
                            {

                                setSnackBarProps({
                                    ...snackBarProps,
                                    openSnack: true,
                                    variant: 'success',
                                    message: 'Status updated successfully',
                                });
                                GetAllSocialResposibility();
                                if (eventInfo.readonlyOrHide === 0)
                                {
                                    await saveAppNotification(newRequestNote);
                                }
                                closeNoteDialog();
                            }
                        }).catch(err =>
                        {
                            console.log(err);
                        })
                }
            }).catch(err =>
            {
                console.log(err);
            })
    }
    const handlePendingAction = () =>
    {
        const req = requestPending.attach(Downgraded).get();
        console.log(req)
        const updateStatus = {
            userID: req.userID,
            Status: req.status,
            ModifiedBy: userID.get(),
            eventID: req.eventID,
            isMail: 1
        };
        console.log(updateStatus)
        ApiHelper.post(APIURLConstants.UPD_SOCIALRESPONSIBILITY_STATUS, updateStatus)
            .then(async (res) =>
            {
                if (res.data)
                {

                    pendingAction.set({
                        open: false,
                        title: '',
                        OkButtonText: 'Ok',
                        message: '',
                    });
                    requestPending.set(null)
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request updated successfully',
                    });
                    GetAllSocialResposibility();
                }
            })
    }
    const multiApprove = () =>
    {
        const selected = allData.attach(Downgraded).get().filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length===0)
        {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else
        {
            let message = setAll.get()
                ? 'Do you want to Approve all request?'
                : 'Do you want to Approve selected request?';
            allNote.set(true)
            approveConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    }
    const multiReject = () =>
    {
        const selected = allData.attach(Downgraded).get().filter((user) => user.selected === true);
        const selected1 = fullData
            .attach(Downgraded)
            .get()
            .filter((user) => user.selected === true);
        if (selected.length === 0 && selected1.length===0)
        {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select request first',
            });
        } else
        {
            let message = setAll.get()
                ? 'Do you want to Reject all request?'
                : 'Do you want to Reject selected request?';
            allNote.set(true)
            rejectConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    }
    const handleRejectConfirmation = () =>
    {
        let rejectRequests = [];
        allData.get().map((row) =>
        {
            if (row.selected === true)
            {
                rejectRequests.push({userID:row.actualData.userID});
            }
        });
        fullData.get().map((row) =>
        {
            if (row.selected === true)
            {
                rejectRequests.push(row.actualData.userID);
            }
        });
        const eventInfo = Helper.getStorage('eventInfo');
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(rejectRequests),
            Status: 3,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: 14,
            ModifiedBy: userID.value,
            TemplateType:"SocialResp",
            TransportType:"SocialResp",
            appNotificationTypeID:1,
        })
            .then((res) =>
            {
                if (res.data)
                {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request rejected successfully',
                    });
                    setAll.set(false);
                    GetAllSocialResposibility();
                }
            })
            .catch((error) =>
            {
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while reject request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        rejectConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });

    }
    const handleApproveConfirmation = () =>
    {
        let approveRequests = [];
        allData.get().map((row) =>
        {
            if (row.selected === true)
            {
                approveRequests.push({userID:row.actualData.userID});
            }
        });
        fullData.get().map((row) =>
        {
            if (row.selected === true)
            {
                approveRequests.push(row.actualData.userID);
            }
        });
        const eventInfo = Helper.getStorage('eventInfo');
        ApiHelper.post(APIURLConstants.UPDATE_MULTI_SELECT_STATUS, {
            Ids: JSON.stringify(approveRequests),
            Status: 2,
            Note: allNoteValue,
            EventID: eventInfo.eventID,
            ModuleID: 14,
            ModifiedBy: userID.value,
            TemplateType:"SocialResp",
            TransportType:"SocialResp",
            appNotificationTypeID:1,
        })
            .then((res) =>
            {
                console.log("res", res)
                if (res.data)
                {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request approved successfully',
                    });
                    setAll.set(false);
                    GetAllSocialResposibility();
                }
            })
            .catch((error) =>
            {
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while approve request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        approveConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    }

    const showApproveAndReject = () =>
    {

    }
    const showHistory = (item) =>
    {
        setShowSocialHistory(true);
        getHistory(item.actualData.socialResponsibilityID);
    };
    const getHistory=(id)=>{
        ApiHelper.get(APIURLConstants.GET_SOCIAL_RESP_HISTORY(id, eventInfo.eventID)).then(
            (res) =>
            {
                let arr = [];
                res.data.map((item, index, originalArr) =>
                {
                    console.log(item, index,originalArr);
                    let txt = [];
                    let preTxt = [];
                    let previous = originalArr[index - 1];
                    if (
                        item.eventForm &&
                        item.eventForm !== null &&
                        item.eventForm !== ''
                    )
                    {
                        item.eventForm = JSON.parse(item.eventForm);
                        item.eventForm?.FormFields?.forEach((item) =>
                        {
                            if (item.find((x) => x.FieldValue))
                            {
                                txt.push(
                                    item.find((x) => x.FieldValue)?.FieldName
                                );
                            }
                        });
                    }
                    if (
                        previous?.eventForm &&
                        previous?.eventForm !== null &&
                        previous?.eventForm !== ''
                    )
                    {
                        let form = previous?.eventForm;
                        form?.FormFields?.forEach((itm) =>
                        {
                            if (itm.find((x) => x.FieldValue))
                            {
                                preTxt.push(
                                    itm.find((x) => x.FieldValue)?.FieldName
                                );
                            }
                        });
                    }
                    arr.push({
                        actualData: item,
                        row: [ 
                            {
                                participant: item.participant,
                                highlight:
                                    index > 0
                                        ? previous?.participant !==
                                            item.participant
                                            ? true
                                            : false
                                        : false,
                            },
                             
                            {
                                title: item.title,
                                highlight:
                                    index > 0
                                        ? previous?.title !==
                                            item.title
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                specialRequest: item.specialRequest,
                                highlight:
                                    index > 0
                                        ? previous?.specialRequest !==
                                            item.specialRequest
                                            ? true
                                            : false
                                        : false,
                            },
                            // {
                            //     preference: item.preference,
                            //     highlight:
                            //         index > 0
                            //             ? previous?.preference !==
                            //                 item.preference
                            //                 ? true
                            //                 : false
                            //             : false,
                            // }, 
                            {
                                RequestStatus: item.requestStatus,
                                highlight:
                                    index > 0
                                        ? previous?.requestStatus !==
                                            item.requestStatus
                                            ? true
                                            : false
                                        : false,
                            },  
                            {
                                AuditBy: item.auditBy,
                                highlight:
                                    index > 0
                                        ? previous?.auditBy !==
                                            item.auditBy
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                AuditDate: Helper.FormatDateTime(item.auditDate),
                                highlight:
                                    index > 0
                                        ? previous?.auditDate !==
                                            item.auditDate
                                            ? true
                                            : false
                                        : false,
                            },
                            {
                                AuditStatus: item.auditStatus,
                                highlight:
                                    index > 0
                                        ? previous?.auditStatus !==
                                            item.auditStatus
                                            ? true
                                            : false
                                        : false,
                            },
                        ],
                    });
                });
                setSocialRespHistory(arr);
            }
        );
    }
    const renderDialogActions = () => { };

    const renderDialogContent = () =>
    {
        let finalHeaders = [...headers];
        let finalDataHistory =
            socialRespHistory &&
            JSON.parse(JSON.stringify(socialRespHistory));

        return (
            <StyledTable1 rowHeader={finalHeaders} data={finalDataHistory} />
        );
    };
    return (
        <Box className={loading.get() ? 'alignCenter' : 'otherContentBox'}
        sx={{
            overflow:'auto',
            maxHeight:'calc(100vh - 70px)',
        }}
        >
            {
                loading.get() ? (
                    <Box className={classes.loader}>
                        <CircularProgress />
                    </Box>
                ) :
                    modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                        <UnauthorizedUI showLogout={false} />
                    ) : (
                        <DataSocialResList
                            // new props
                            data={allData.attach(Downgraded).get()}
                            allData={fullData.attach(Downgraded).get()}
                            title={''}
                            buttonTitle={'Add'}
                            deleteRows={onDelete}
                            showSearch={showSearch}
                            filterChangeVal={filterChangeVal}
                            loading={loading.get()}
                            searchLabel={'Search'}
                            // showFilter={true}
                            filters={filters}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            getResults={GetAllSocialResposibility}
                            pagingInfo={pagingInfo.attach(Downgraded).get()}
                            handlePageChange={handlePageChange}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            filterListData={filterListData}
                            // moduleToShow={'Social Responsibility'}
                            callExport={callExport}
                            disableAdd={false}
                            hideDelete={false}
                            showEdit={true}
                            hideAdd={false}
                            onActionClick={onActionClick}
                            onPendingAction={onPendingAction}
                            handleClick={onAddRequest}
                            showRequestStatus={showStatus}
                            showApproveAndReject={showApproveAndReject}
                            editRow={redirectToEditRequest}
                            multiApprove={multiApprove}
                            multiReject={multiReject}
                            showHistory={showHistory}
                        />
                    )
            }
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {openNoteDialog.get() && (
                <AdminNote
                    open={openNoteDialog.get()}
                    title={`${requestNote.get().action} Note`}
                    handleClose={closeNoteDialog}
                    updateNote={updateNote}
                    data={requestNote.attach(Downgraded).get()}
                />
            )}
            {
                <PendingActionDialog
                    open={pendingAction.get().open}
                    message={pendingAction.get().message}
                    OkButtonText={pendingAction.get().OkButtonText}
                    handleCnfClick={() =>
                        handlePendingAction(pendingAction)
                    }
                    onCancelClick={() =>
                    {
                        pendingAction.set({
                            ...pendingAction.get(),
                            open: false,
                        });
                    }}></PendingActionDialog>
            }

            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() =>
                    {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={rejectConfirmation.get().open}
                    message={rejectConfirmation.get().message}
                    OkButtonText={rejectConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleRejectConfirmation(rejectConfirmation)
                    }
                    onCancelClick={() =>
                    {
                        rejectConfirmation.set({
                            ...rejectConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
            {
                <ConfirmationDialog
                    open={approveConfirmation.get().open}
                    message={approveConfirmation.get().message}
                    OkButtonText={approveConfirmation.get().OkButtonText}
                    note={allNote}
                    allNoteValue={hanldeAllNoteValue}
                    handleCnfClick={() =>
                        handleApproveConfirmation(approveConfirmation)
                    }
                    onCancelClick={() =>
                    {
                        approveConfirmation.set({
                            ...approveConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>                    
            }
            {showSocialHistory && (
                <CustomDialog
                    TransitionComponent={Transition}
                    title={'Social Impact History'}
                    maxWidth="xl"
                    showClose={true}
                    open={showHistory}
                    handleClose={() =>
                    {
                        setShowSocialHistory(false);
                    }}
                    fullWidth={true}
                    renderContent={renderDialogContent}
                    renderActions={renderDialogActions}
                />
            )}
        </Box>
    );
};

// export default {
//     routeProps: {
//         path: RouteConstants.EVENT_SOCIAL_RESPONSIBILITY,
//         component: SocialResponsibilityList,
//     },
//     name: 'SocialResponsibilityList',
// };
export default SocialResponsibilities
